import { render, staticRenderFns } from "./step_1.vue?vue&type=template&id=3edcb5b0&scoped=true&lang=pug&"
import script from "./step_1.vue?vue&type=script&lang=js&"
export * from "./step_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edcb5b0",
  null
  
)

export default component.exports